import React from "react";
import PropTypes from "prop-types";
import { Warning } from "MODULES/shared/components/Warning";
import { renderIf } from "MODULES/shared/decorators";

function renderWarning({ part, domFromLineItem }) {
  if (!part || !part.dom_life_years || !part.llp || !domFromLineItem)
    return false;
  const today = new Date().getTime();
  const dom = new Date(domFromLineItem).getTime();
  const yearsRemaining = (today - dom) / (24 * 60 * 60 * 365 * 1000);
  return today > dom && yearsRemaining >= part.dom_life_years * 0.6;
}

function DomLifeWarning() {
  return (
    <Warning>
      The DOM Life for this item is less than 40% and will require Manager
      Approval
    </Warning>
  );
}

DomLifeWarning.propTypes = {
  part: PropTypes.shape({
    dom_life_years: PropTypes.number.isRequired,
    llp: PropTypes.bool.isRequired
  }).isRequired
};

export default renderIf(({ part, domFromLineItem }) =>
  renderWarning({ part, domFromLineItem })
)(DomLifeWarning);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/DomLifeWarning.jsx